import React, { useState, useEffect } from 'react';
import { Plus, Edit2, Trash2, Search, Grid, List, Eye, EyeOff, Star, StarOff, DollarSign, ArrowUp, ArrowDown, Package, Hash, Filter, X } from 'lucide-react';
import { useAuth } from '../contexts/AuthContext';

const ProductVariantsManagement = () => {
  const { user, restaurants: userRestaurants } = useAuth();
  const [variants, setVariants] = useState([]);
  const [products, setProducts] = useState([]);
  const [categories, setCategories] = useState([]);
  const [restaurants, setRestaurants] = useState([]);
  const [loading, setLoading] = useState(true);
  const [searchTerm, setSearchTerm] = useState('');
  const [selectedRestaurant, setSelectedRestaurant] = useState('');
  const [selectedCategory, setSelectedCategory] = useState('');
  const [selectedProduct, setSelectedProduct] = useState('');
  const [showModal, setShowModal] = useState(false);
  const [editingVariant, setEditingVariant] = useState(null);
  const [viewMode, setViewMode] = useState('grid');
  const [showFilters, setShowFilters] = useState(false);
  const [filters, setFilters] = useState({
    isActive: '',
    isDefault: '',
    priceModifierType: '' // positive, negative, zero
  });
  const [formData, setFormData] = useState({
    productId: '',
    name: '',
    description: '',
    priceModifier: '',
    isDefault: false,
    displayOrder: 0,
    isActive: true
  });

  // API Configuration
  const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;

  // API Services
  const variantService = {
    getAll: async () => {
      if (!user) return [];
      
      console.log('Calling product variants API...');
      try {
        const token = localStorage.getItem('authToken');
        const response = await fetch(`${API_BASE_URL}/api/productvariants`, {
          method: 'GET',
          headers: {
            'Authorization': `Bearer ${token}`,
            'Content-Type': 'application/json',
            'Accept': 'application/json'
          },
          mode: 'cors'
        });
        
        if (!response.ok) {
          throw new Error(`HTTP error! status: ${response.status} - ${response.statusText}`);
        }
        
        const data = await response.json();
        console.log('Product variants data:', data);
        return data;
      } catch (error) {
        console.error('Product variants API error:', error);
        throw error;
      }
    },
    create: async (data) => {
      const token = localStorage.getItem('authToken');
      const response = await fetch(`${API_BASE_URL}/api/productvariants`, {
        method: 'POST',
        headers: { 
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json',
          'Accept': 'application/json'
        },
        mode: 'cors',
        body: JSON.stringify(data)
      });
        if (!response.ok) {
            // Sunucu hata mesajını al
            const errorText = await response.text();
            console.error('Server error:', errorText);
            throw new Error(`HTTP error! status: ${response.status}, message: ${errorText}`);
        }
        return response.json(); 
    },
      // variantService.update fonksiyonunuzu şöyle güncelleyin:
      update: async (id, data) => {
          const token = localStorage.getItem('authToken');
          const response = await fetch(`${API_BASE_URL}/api/productvariants/${id}`, {
              method: 'PUT',
              headers: {
                  'Authorization': `Bearer ${token}`,
                  'Content-Type': 'application/json',
                  'Accept': 'application/json'
              },
              mode: 'cors',
              body: JSON.stringify(data)
          });

          if (!response.ok) {
              const errorText = await response.text();
              throw new Error(`HTTP error! status: ${response.status}, message: ${errorText}`);
          }

          // JSON parse etmeyin - sadece status kontrolü yeterli
          return { success: true };
      },
    delete: async (id) => {
      const token = localStorage.getItem('authToken');
      const response = await fetch(`${API_BASE_URL}/api/productvariants/${id}`, {
        method: 'DELETE',
        headers: {
          'Authorization': `Bearer ${token}`,
          'Accept': 'application/json'
        },
        mode: 'cors'
      });
      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }
      return response.ok;
    }
  };
    console.log('Products loaded:', products);
    console.log('Products length:', products.length);
  const productService = {
    getAll: async () => {
      if (!user) return [];
      
      try {
        const token = localStorage.getItem('authToken');
        let url = `${API_BASE_URL}/api/Products`;
        
        // Convert numeric role to string for comparison
        const userRole = typeof user.role === 'number' ? 
          (user.role === 1 ? 'Admin' : user.role === 2 ? 'Manager' : user.role === 3 ? 'SuperAdmin' : 'User') : 
          user.role;
        
        // If user is not SuperAdmin, filter by their restaurant
        if (userRole !== 'SuperAdmin') {
          url = `${API_BASE_URL}/api/Products/user/${user.id}`;
        }

        const response = await fetch(url, {
          method: 'GET',
          headers: {
            'Authorization': `Bearer ${token}`,
            'Content-Type': 'application/json'
          }
        });

        if (response.ok) {
          const data = await response.json();
          return data;
        } else {
          throw new Error(`HTTP error! status: ${response.status}`);
        }
      } catch (error) {
        console.error('Products API Error:', error);
        throw error;
      }
    }
  };

  const categoryService = {
    getAll: async () => {
      if (!user) return [];
      
      try {
        const token = localStorage.getItem('authToken');
        let url = `${API_BASE_URL}/api/Categories`;
        
        // Convert numeric role to string for comparison
        const userRole = typeof user.role === 'number' ? 
          (user.role === 1 ? 'Admin' : user.role === 2 ? 'Manager' : user.role === 3 ? 'SuperAdmin' : 'User') : 
          user.role;
        
        // If user is not SuperAdmin, filter by their restaurant
        if (userRole !== 'SuperAdmin') {
          url = `${API_BASE_URL}/api/Categories/user/${user.id}`;
        }

        const response = await fetch(url, {
          method: 'GET',
          headers: {
            'Authorization': `Bearer ${token}`,
            'Content-Type': 'application/json'
          }
        });

        if (response.ok) {
          const data = await response.json();
          return data;
        } else {
          throw new Error(`HTTP error! status: ${response.status}`);
        }
      } catch (error) {
        console.error('Categories API Error:', error);
        throw error;
      }
    }
  };

  const restaurantService = {
    getAll: async () => {
      if (!user) return [];
      
      try {
        const token = localStorage.getItem('authToken');
        let url = `${API_BASE_URL}/api/Restaurants`;
        
        // Convert numeric role to string for comparison
        const userRole = typeof user.role === 'number' ? 
          (user.role === 1 ? 'Admin' : user.role === 2 ? 'Manager' : user.role === 3 ? 'SuperAdmin' : 'User') : 
          user.role;
        
        // If user is not SuperAdmin, filter by their restaurant
        if (userRole !== 'SuperAdmin') {
          url = `${API_BASE_URL}/api/Restaurants/user/${user.id}`;
        }

        const response = await fetch(url, {
          method: 'GET',
          headers: {
            'Authorization': `Bearer ${token}`,
            'Content-Type': 'application/json'
          }
        });

        if (response.ok) {
          const data = await response.json();
          return data;
        } else {
          throw new Error(`HTTP error! status: ${response.status}`);
        }
      } catch (error) {
        console.error('Restaurant API Error:', error);
        throw error;
      }
    }
  };

  // Load Data
  const fetchData = async () => {
    if (!user) return;
    
    setLoading(true);
    try {
      console.log('🔄 Fetching all data...');
      
      // Use userRestaurants if available, otherwise fetch from API
      let restaurantsData;
      if (userRestaurants && userRestaurants.length > 0) {
        restaurantsData = userRestaurants;
        setRestaurants(restaurantsData);
      } else {
        restaurantsData = await restaurantService.getAll();
        setRestaurants(restaurantsData);
      }
      
      const [variantsData, productsData, categoriesData] = await Promise.all([
        variantService.getAll(),
        productService.getAll(),
        categoryService.getAll()
      ]);
      
      console.log('✅ All data loaded successfully');
      setVariants(variantsData);
      setProducts(productsData);
      setCategories(categoriesData);
    } catch (error) {
      console.error('❌ Error fetching data:', error);
      setVariants([]);
      setProducts([]);
      setCategories([]);
      setRestaurants([]);
      alert(`API Hatası: ${error.message}`);
    } finally {
      setLoading(false);
    }
  };

    // ProductId'nin doğru formatta olduğunu kontrol edin
    const createVariant = async () => {
        try {
            // Validation
            if (!formData.productId) {
                alert('Lütfen bir ürün seçiniz!');
                return;
            }

            if (!formData.name) {
                alert('Lütfen variant adı giriniz!');
                return;
            }

            console.log('Validation passed, submitting...');

            const requestData = {
                productId: formData.productId,
                name: formData.name,
                description: formData.description || "",
                priceModifier: Number(formData.priceModifier) || 0,
                isDefault: Boolean(formData.isDefault) || false,
                displayOrder: Number(formData.displayOrder) || 0,
                isActive: Boolean(formData.isActive) !== false
            };

            await variantService.create(requestData);
            await fetchData();
            resetForm();
            setShowModal(false);
        } catch (error) {
            console.error('Error creating variant:', error);
            alert(`Varyant oluşturulurken bir hata oluştu: ${error.message}`);
        }
    };

    const isValidGuid = (str) => {
        const guidRegex = /^[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/i;
        return guidRegex.test(str);
    };
  
     




    const updateVariant = async () => {
        if (!editingVariant) return;

        try {
            const variantId = editingVariant.id;

            const requestData = {
                id: variantId, // Bu satırı ekleyin
                productId: formData.productId,
                name: formData.name,
                description: formData.description || "",
                priceModifier: Number(formData.priceModifier) || 0,
                isDefault: Boolean(formData.isDefault) || false,
                displayOrder: Number(formData.displayOrder) || 0,
                isActive: Boolean(formData.isActive) !== false
            };

            await variantService.update(variantId, requestData);
            await fetchData();
            resetForm();
            setShowModal(false);
        } catch (error) {
            console.error('Error updating variant:', error);
            alert(`Hata: ${error.message}`);
        }
    };
  const deleteVariant = async (id) => {
    if (!id) {
      console.error('Delete variant called with undefined or null id');
      alert('Varyant ID bulunamadı!');
      return;
    }
    
    if (window.confirm('Bu varyantı silmek istediğinizden emin misiniz?')) {
      try {
        console.log('Deleting variant with ID:', id);
        await variantService.delete(id);
        await fetchData();
      } catch (error) {
        console.error('Error deleting variant:', error);
        alert('Varyant silinirken bir hata oluştu!');
      }
    }
  };

  const toggleVariantStatus = async (variant, field) => {
    try {
      const updatedData = { ...variant, [field]: !variant[field] };
      await variantService.update(variant.id, updatedData);
      await fetchData();
    } catch (error) {
      console.error(`Error toggling variant ${field}:`, error);
      alert(`Varyant ${field} değiştirilirken bir hata oluştu!`);
    }
  };

  const moveVariant = async (variantId, direction) => {
    const variant = variants.find(v => v.id === variantId);
    if (!variant) return;

    const productVariants = variants
      .filter(v => v.productId === variant.productId)
      .sort((a, b) => a.displayOrder - b.displayOrder);

      const currentIndex = productVariants.findIndex(v => v.id === variantId);
    const newIndex = direction === 'up' ? currentIndex - 1 : currentIndex + 1;

    if (newIndex < 0 || newIndex >= productVariants.length) return;

    try {
      const currentVariant = productVariants[currentIndex];
      const targetVariant = productVariants[newIndex];

      // Swap display orders
      const tempOrder = currentVariant.displayOrder;
      currentVariant.displayOrder = targetVariant.displayOrder;
      targetVariant.displayOrder = tempOrder;

      // Update both variants via API
      await Promise.all([
          variantService.update(currentVariant.id, currentVariant),
          variantService.update(targetVariant.id, targetVariant)
      ]);

      await fetchData();
    } catch (error) {
      console.error('Error moving variant:', error);
      alert('Varyant taşınırken bir hata oluştu!');
    }
  };

  const resetForm = () => {
    setFormData({
      productId: '',
      name: '',
      description: '',
      priceModifier: '',
      isDefault: false,
      displayOrder: 0,
      isActive: true
    });
  };

  const openModal = (variant) => {
    if (variant) {
      setEditingVariant(variant);
      setFormData({
        productId: variant.productId,
        name: variant.name,
        description: variant.description || '',
        priceModifier: variant.priceModifier ? variant.priceModifier.toString() : '0',
        isDefault: variant.isDefault || false,
        displayOrder: variant.displayOrder || 0,
        isActive: variant.isActive
      });
    } else {
      setEditingVariant(null);
      resetForm();
    }
    setShowModal(true);
  };

    const getProductName = (productId) => {
        const product = products.find(p => p.id === productId); // id ile ara
        return product ? product.name : 'Bilinmeyen Ürün';
    };

  const getCategoryName = (productId) => {
    const product = products.find(p => p.id === productId);
    if (!product) return 'Bilinmeyen Kategori';
    const category = categories.find(c => c.id === product.categoryId);
    return category ? category.name : 'Bilinmeyen Kategori';
  };

  const getRestaurantName = (productId) => {
    const product = products.find(p => p.id === productId);
    if (!product) return 'Bilinmeyen Restoran';
    const restaurant = restaurants.find(r => r.id === product.restaurantId);
    return restaurant ? restaurant.name : 'Bilinmeyen Restoran';
  };

  const formatPriceModifier = (modifier) => {
    const value = parseFloat(modifier);
    if (value === 0) return 'Fiyat Değişikliği Yok';
    if (value > 0) return `+₺${value}`;
    return `₺${value}`;
  };

  const getPriceModifierColor = (modifier) => {
    const value = parseFloat(modifier);
    if (value === 0) return 'text-gray-600';
    if (value > 0) return 'text-green-600';
    return 'text-red-600';
  };

  const clearFilters = () => {
    setFilters({
      isActive: '',
      isDefault: '',
      priceModifierType: ''
    });
    setSelectedRestaurant('');
    setSelectedCategory('');
    setSelectedProduct('');
    setSearchTerm('');
  };

    const filteredVariants = variants.filter(variant => {
       
    // Text search
    const matchesSearch = variant.name.toLowerCase().includes(searchTerm.toLowerCase()) ||
      (variant.description && variant.description.toLowerCase().includes(searchTerm.toLowerCase()));

    // Product filter (which includes restaurant and category filtering)
        const product = products.find(p => p.id === variant.productId);
        if (!product) {
            return false;
        }
         

    const matchesRestaurant = !selectedRestaurant || (product && product.restaurantId === selectedRestaurant);
    const matchesCategory = !selectedCategory || (product && product.categoryId === selectedCategory);
    const matchesProduct = !selectedProduct || variant.productId === selectedProduct;
         
    // Advanced filters
    const matchesActive = filters.isActive === '' || 
      (filters.isActive === 'true' && variant.isActive) ||
      (filters.isActive === 'false' && !variant.isActive);

    const matchesDefault = filters.isDefault === '' || 
      (filters.isDefault === 'true' && variant.isDefault) ||
      (filters.isDefault === 'false' && !variant.isDefault);

    const matchesPriceModifierType = () => {
      if (!filters.priceModifierType) return true;
      const value = parseFloat(variant.priceModifier || 0);
      if (filters.priceModifierType === 'positive') return value > 0;
      if (filters.priceModifierType === 'negative') return value < 0;
      if (filters.priceModifierType === 'zero') return value === 0;
      return true;
    };
        
    return matchesSearch && matchesRestaurant && matchesCategory && matchesProduct && 
           matchesActive && matchesDefault && matchesPriceModifierType();
  });
   
  const availableCategories = categories.filter(cat => 
    !selectedRestaurant || cat.restaurantId === selectedRestaurant
  );

  const availableProducts = products.filter(prod => {
    const matchesRestaurant = !selectedRestaurant || prod.restaurantId === selectedRestaurant;
    const matchesCategory = !selectedCategory || prod.categoryId === selectedCategory;
    return matchesRestaurant && matchesCategory;
  });

  useEffect(() => {
    if (userRestaurants && userRestaurants.length > 0) {
      setRestaurants(userRestaurants);
    }
    fetchData();
  }, [userRestaurants]);

  return (
    <div className="min-h-screen bg-gray-50 p-6">
      <div className="max-w-7xl mx-auto">
        {/* Header */}
        <div className="mb-8">
          <h1 className="text-3xl font-bold text-gray-900 mb-2">Ürün Varyantları Yönetimi</h1>
          <p className="text-gray-600">Ürün boyutları, seçenekleri ve fiyat değiştiricilerini yönetin</p>
        </div>

        {/* Filters and Actions */}
        <div className="bg-white rounded-lg shadow-sm border border-gray-200 p-4 mb-6">
          <div className="flex flex-col lg:flex-row gap-4 items-center justify-between">
            <div className="flex flex-col sm:flex-row gap-4 flex-1">
              {/* Search */}
              <div className="relative flex-1 max-w-md">
                <Search className="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400 w-5 h-5" />
                <input
                  type="text"
                  placeholder="Varyant ara..."
                  value={searchTerm}
                  onChange={(e) => setSearchTerm(e.target.value)}
                  className="w-full pl-10 pr-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                />
              </div>

              {/* Restaurant Filter */}
              <select
                value={selectedRestaurant}
                              onChange={(e) => { 
                                  setSelectedRestaurant(e.target.value);
                                  setSelectedCategory('');
                                  setSelectedProduct('');
                              }}
                className="px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent"
              >
                <option value="">Tüm Restoranlar</option>
                {restaurants.map(restaurant => (
                    <option key={restaurant.id} value={restaurant.id}>
                        {restaurant.name}
                    </option>
                ))}
              </select>

              {/* Category Filter */}
              <select
                value={selectedCategory}
                onChange={(e) => {
                  setSelectedCategory(e.target.value);
                  setSelectedProduct('');
                }}
                className="px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                disabled={!selectedRestaurant}
              >
                <option value="">Tüm Kategoriler</option>
                {availableCategories.map(category => (
                    <option key={category.id} value={category.id}>
                        {category.name}
                    </option>
                ))}
              </select>

              {/* Product Filter */}
                          <select
                              value={selectedProduct}
                              onChange={(e) => setSelectedProduct(e.target.value)}
                              className="px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                          >
                              <option value="">Tüm Ürünler</option>
                              {availableProducts.map(product => (
                                  <option key={product.id} value={product.id}>
                                      {product.name}
                                  </option>
                              ))}
                          </select>
            </div>

            <div className="flex items-center gap-3">
              {/* Advanced Filters Toggle */}
              <button
                onClick={() => setShowFilters(!showFilters)}
                className={`p-2 border border-gray-300 rounded-lg ${showFilters ? 'bg-blue-500 text-white' : 'bg-white text-gray-600 hover:bg-gray-50'}`}
                title="Advanced Filters"
              >
                <Filter className="w-4 h-4" />
              </button>

              {/* Clear Filters */}
              <button
                onClick={clearFilters}
                className="p-2 border border-gray-300 rounded-lg bg-white text-gray-600 hover:bg-gray-50"
                title="Clear Filters"
              >
                <X className="w-4 h-4" />
              </button>

              {/* View Toggle */}
              <div className="flex border border-gray-300 rounded-lg overflow-hidden">
                <button
                  onClick={() => setViewMode('grid')}
                  className={`p-2 ${viewMode === 'grid' ? 'bg-blue-500 text-white' : 'bg-white text-gray-600 hover:bg-gray-50'}`}
                >
                  <Grid className="w-4 h-4" />
                </button>
                <button
                  onClick={() => setViewMode('list')}
                  className={`p-2 ${viewMode === 'list' ? 'bg-blue-500 text-white' : 'bg-white text-gray-600 hover:bg-gray-50'}`}
                >
                  <List className="w-4 h-4" />
                </button>
              </div>

              {/* Add Button */}
              <button
                onClick={() => openModal()}
                className="bg-blue-600 hover:bg-blue-700 text-white px-4 py-2 rounded-lg flex items-center gap-2 transition-colors"
              >
                <Plus className="w-5 h-5" />
                Yeni Varyant
              </button>
            </div>
          </div>

          {/* Advanced Filters Panel */}
          {showFilters && (
            <div className="mt-4 pt-4 border-t border-gray-200">
              <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
                {/* Status Filter */}
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-2">Durum</label>
                  <select
                    value={filters.isActive}
                    onChange={(e) => setFilters({...filters, isActive: e.target.value})}
                    className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                  >
                    <option value="">Tümü</option>
                    <option value="true">Aktif</option>
                    <option value="false">Pasif</option>
                  </select>
                </div>

                {/* Default Filter */}
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-2">Varsayılan</label>
                  <select
                    value={filters.isDefault}
                    onChange={(e) => setFilters({...filters, isDefault: e.target.value})}
                    className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                  >
                    <option value="">Tümü</option>
                    <option value="true">Varsayılan</option>
                    <option value="false">Normal</option>
                  </select>
                </div>

                {/* Price Modifier Type */}
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-2">Fiyat Etkisi</label>
                  <select
                    value={filters.priceModifierType}
                    onChange={(e) => setFilters({...filters, priceModifierType: e.target.value})}
                    className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                  >
                    <option value="">Tümü</option>
                    <option value="positive">Fiyat Artırır (+)</option>
                    <option value="negative">Fiyat Azaltır (-)</option>
                    <option value="zero">Fiyat Değiştirmez (0)</option>
                  </select>
                </div>
              </div>
            </div>
          )}
        </div>

        {/* Variants Grid/List */}
        {loading ? (
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
            {[...Array(6)].map((_, i) => (
              <div key={i} className="bg-white rounded-lg shadow-sm border border-gray-200 p-6 animate-pulse">
                <div className="h-4 bg-gray-200 rounded w-3/4 mb-4"></div>
                <div className="h-3 bg-gray-200 rounded w-full mb-2"></div>
                <div className="h-3 bg-gray-200 rounded w-2/3"></div>
              </div>
            ))}
          </div>
        ) : filteredVariants.length === 0 ? (
          <div className="text-center py-12">
            <Package className="w-16 h-16 text-gray-300 mx-auto mb-4" />
            <h3 className="text-lg font-medium text-gray-900 mb-2">Varyant bulunamadı</h3>
            <p className="text-gray-500 mb-4">Arama kriterlerinize uygun varyant bulunmuyor.</p>
            <button
              onClick={() => openModal()}
              className="bg-blue-600 hover:bg-blue-700 text-white px-4 py-2 rounded-lg"
            >
              İlk varyantı oluştur
            </button>
          </div>
        ) : viewMode === 'grid' ? (
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
            {filteredVariants.map((variant) => (
                              <div key={variant.id} className="bg-white rounded-lg shadow-sm border border-gray-200 hover:shadow-md transition-shadow">
                <div className="p-6">
                  <div className="flex items-start justify-between mb-4">
                    <div className="flex items-center gap-3 flex-1">
                      <div className="text-2xl">📏</div>
                      <div className="flex-1">
                        <h3 className="text-lg font-semibold text-gray-900 mb-1">{variant.name}</h3>
                        <p className="text-sm text-gray-500">{getProductName(variant.productId)}</p>
                        <p className="text-xs text-gray-400">{getCategoryName(variant.productId)} • {getRestaurantName(variant.productId)}</p>
                      </div>
                    </div>
                    <div className="flex items-center gap-2">
                      <span className="text-xs bg-gray-100 text-gray-600 px-2 py-1 rounded flex items-center gap-1">
                        <Hash className="w-3 h-3" />
                        {variant.displayOrder}
                      </span>
                      {variant.isDefault && (
                        <span className="text-xs bg-blue-100 text-blue-800 px-2 py-1 rounded flex items-center gap-1">
                          <Star className="w-3 h-3" />
                          Varsayılan
                        </span>
                      )}
                    </div>
                  </div>

                  {variant.description && (
                    <p className="text-gray-600 text-sm mb-4">{variant.description}</p>
                  )}

                  {/* Price Modifier */}
                  <div className="mb-4">
                    <div className={`flex items-center gap-2 font-medium ${getPriceModifierColor(variant.priceModifier)}`}>
                      <DollarSign className="w-4 h-4" />
                      {formatPriceModifier(variant.priceModifier)}
                    </div>
                  </div>

                  <div className="flex items-center justify-between pt-4 border-t border-gray-100">
                    <span className={`inline-flex px-2 py-1 text-xs font-medium rounded-full ${
                      variant.isActive ? 'bg-green-100 text-green-800' : 'bg-red-100 text-red-800'
                    }`}>
                      {variant.isActive ? 'Aktif' : 'Pasif'}
                    </span>
                    <div className="flex gap-1">
                    
                      <button
                        onClick={() => toggleVariantStatus(variant, 'isDefault')}
                        className={`p-1.5 rounded transition-colors ${variant.isDefault ? 'text-blue-600 hover:bg-blue-50' : 'text-gray-400 hover:text-blue-600 hover:bg-blue-50'}`}
                        title={variant.isDefault ? 'Varsayılandan Çıkar' : 'Varsayılan Yap'}
                      >
                        {variant.isDefault ? <Star className="w-4 h-4" /> : <StarOff className="w-4 h-4" />}
                      </button>
                      <button
                        onClick={() => openModal(variant)}
                        className="p-1.5 text-gray-400 hover:text-blue-600 hover:bg-blue-50 rounded transition-colors"
                        title="Düzenle"
                      >
                        <Edit2 className="w-4 h-4" />
                      </button>
                      <button
                        onClick={() => deleteVariant(variant.id)}
                        className="p-1.5 text-gray-400 hover:text-red-600 hover:bg-red-50 rounded transition-colors"
                        title="Sil"
                      >
                        <Trash2 className="w-4 h-4" />
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </div>
        ) : (
          <div className="bg-white rounded-lg shadow-sm border border-gray-200 overflow-hidden">
            <div className="px-6 py-4 border-b border-gray-200 bg-gray-50">
              <div className="grid grid-cols-12 gap-4 text-sm font-medium text-gray-500 uppercase tracking-wider">
                <div className="col-span-1">Sıra</div>
                <div className="col-span-2">Varyant</div>
                <div className="col-span-2">Ürün</div>
                <div className="col-span-2">Kategori</div>
                <div className="col-span-2">Fiyat Etkisi</div>
                <div className="col-span-1">Varsayılan</div>
                <div className="col-span-1">Durum</div>
                <div className="col-span-1">İşlemler</div>
              </div>
            </div>
            <div className="divide-y divide-gray-200">
              {filteredVariants.map((variant) => (
                <div key={variant.id} className="px-6 py-4 hover:bg-gray-50 transition-colors">
                  <div className="grid grid-cols-12 gap-4 items-center">
                    <div className="col-span-1">
                      <span className="text-sm font-medium text-gray-900">#{variant.displayOrder}</span>
                    </div>
                    <div className="col-span-2">
                      <div className="flex items-center gap-2">
                        <span className="text-xl">📏</span>
                        <div>
                          <div className="text-sm font-medium text-gray-900">{variant.name}</div>
                          {variant.description && (
                            <div className="text-xs text-gray-500 truncate">{variant.description}</div>
                          )}
                        </div>
                      </div>
                    </div>
                    <div className="col-span-2">
                      <span className="text-sm text-gray-600">{getProductName(variant.productId)}</span>
                    </div>
                    <div className="col-span-2">
                      <span className="text-sm text-gray-600">{getCategoryName(variant.productId)}</span>
                    </div>
                    <div className="col-span-2">
                      <span className={`text-sm font-medium ${getPriceModifierColor(variant.priceModifier)}`}>
                        {formatPriceModifier(variant.priceModifier)}
                      </span>
                    </div>
                    <div className="col-span-1">
                      {variant.isDefault ? (
                        <span className="inline-flex px-2 py-1 text-xs font-medium bg-blue-100 text-blue-800 rounded-full">
                          Evet
                        </span>
                      ) : (
                        <span className="text-xs text-gray-500">Hayır</span>
                      )}
                    </div>
                    <div className="col-span-1">
                      <span className={`inline-flex px-2 py-1 text-xs font-medium rounded-full ${
                        variant.isActive ? 'bg-green-100 text-green-800' : 'bg-red-100 text-red-800'
                      }`}>
                        {variant.isActive ? 'Aktif' : 'Pasif'}
                      </span>
                    </div>
                    <div className="col-span-1">
                      <div className="flex gap-1">
                        <button
                          onClick={() => moveVariant(variant.id, 'up')}
                          className="p-1.5 text-gray-400 hover:text-blue-600 hover:bg-blue-50 rounded transition-colors"
                          title="Yukarı Taşı"
                        >
                          <ArrowUp className="w-4 h-4" />
                        </button>
                        <button
                          onClick={() => moveVariant(variant.id, 'down')}
                          className="p-1.5 text-gray-400 hover:text-blue-600 hover:bg-blue-50 rounded transition-colors"
                          title="Aşağı Taşı"
                        >
                          <ArrowDown className="w-4 h-4" />
                        </button>
                        <button
                          onClick={() => openModal(variant)}
                          className="p-1.5 text-gray-400 hover:text-blue-600 hover:bg-blue-50 rounded transition-colors"
                          title="Düzenle"
                        >
                          <Edit2 className="w-4 h-4" />
                        </button>
                        <button
                          onClick={() => deleteVariant(variant.id)}
                          className="p-1.5 text-gray-400 hover:text-red-600 hover:bg-red-50 rounded transition-colors"
                          title="Sil"
                        >
                          <Trash2 className="w-4 h-4" />
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        )}
      </div>

      {/* Modal */}
      {showModal && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center p-4 z-50">
          <div className="bg-white rounded-lg shadow-xl max-w-2xl w-full max-h-[90vh] overflow-y-auto">
            <div className="p-6 border-b border-gray-200">
              <h2 className="text-xl font-semibold text-gray-900">
                {editingVariant ? 'Varyant Düzenle' : 'Yeni Varyant Ekle'}
              </h2>
            </div>

            <div className="p-6">
              <div className="space-y-6">
                {/* Product Selection */}
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-2">
                    Ürün *
                  </label>
                                  <select
                                      value={formData.productId}
                                      onChange={(e) => setFormData({ ...formData, productId: e.target.value })}
                                  >
                                      <option value="">Ürün seçiniz</option>
                                      {products.map(product => (
                                          <option
                                              key={product.id}
                                              value={product.id}  // GUID olan id'yi kullan
                                          >
                                              {product.name}
                                          </option>
                                      ))}
                                  </select>
                </div>

                {/* Basic Info */}
                <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                  <div>
                    <label className="block text-sm font-medium text-gray-700 mb-2">
                      Varyant Adı *
                    </label>
                    <input
                      type="text"
                      value={formData.name}
                      onChange={(e) => setFormData({...formData, name: e.target.value})}
                      className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                      placeholder="Küçük, Orta, Büyük..."
                      required
                    />
                  </div>

                  <div>
                    <label className="block text-sm font-medium text-gray-700 mb-2">
                      Sıra Numarası
                    </label>
                    <input
                      type="number"
                      value={formData.displayOrder}
                      onChange={(e) => setFormData({...formData, displayOrder: parseInt(e.target.value) || 0})}
                      className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                      min="0"
                    />
                  </div>
                </div>

                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-2">
                    Açıklama
                  </label>
                  <textarea
                    value={formData.description}
                    onChange={(e) => setFormData({...formData, description: e.target.value})}
                    rows={3}
                    className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                    placeholder="Varyant açıklaması..."
                  />
                </div>

                {/* Price Modifier */}
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-2">
                    Fiyat Değiştirici (₺)
                  </label>
                  <div className="relative">
                    <input
                      type="number"
                      value={formData.priceModifier}
                      onChange={(e) => setFormData({...formData, priceModifier: e.target.value})}
                      className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                      step="0.01"
                      placeholder="0.00"
                    />
                    <div className="mt-2 text-sm text-gray-500">
                      <div className="grid grid-cols-1 md:grid-cols-3 gap-2">
                        <div className="text-green-600">• Pozitif değer: Fiyata eklenir (+5₺)</div>
                        <div className="text-red-600">• Negatif değer: Fiyattan çıkarılır (-3₺)</div>
                        <div className="text-gray-600">• Sıfır: Fiyat değişmez</div>
                      </div>
                    </div>
                  </div>
                </div>

                {/* Price Preview */}
                {formData.productId && formData.priceModifier && (
                  <div className="bg-blue-50 border border-blue-200 rounded-lg p-4">
                    <h4 className="text-sm font-medium text-blue-900 mb-2">Fiyat Önizlemesi</h4>
                    {(() => {
                      const product = products.find(p => p.id === formData.productId);
                      if (!product) return null;
                      
                      const basePrice = parseFloat(product.price);
                      const modifier = parseFloat(formData.priceModifier || 0);
                      const newPrice = basePrice + modifier;
                      
                      return (
                        <div className="text-sm">
                          <div className="flex items-center gap-2 text-gray-700">
                            <span>Temel Fiyat:</span>
                            <span className="font-medium">₺{basePrice}</span>
                          </div>
                          <div className="flex items-center gap-2 text-gray-700">
                            <span>Değiştirici:</span>
                            <span className={`font-medium ${getPriceModifierColor(modifier)}`}>
                              {formatPriceModifier(modifier)}
                            </span>
                          </div>
                          <div className="flex items-center gap-2 text-blue-900 font-semibold mt-1 pt-1 border-t border-blue-200">
                            <span>Yeni Fiyat:</span>
                            <span>₺{newPrice.toFixed(2)}</span>
                          </div>
                        </div>
                      );
                    })()}
                  </div>
                )}

                {/* Status Options */}
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-3">
                    Durum Seçenekleri
                  </label>
                  <div className="flex flex-wrap gap-4">
                    <label className="flex items-center gap-2">
                      <input
                        type="checkbox"
                        checked={formData.isActive}
                        onChange={(e) => setFormData({...formData, isActive: e.target.checked})}
                        className="rounded border-gray-300 text-blue-600 focus:ring-blue-500"
                      />
                      <span className="text-sm text-gray-700">Aktif</span>
                    </label>

                    <label className="flex items-center gap-2">
                      <input
                        type="checkbox"
                        checked={formData.isDefault}
                        onChange={(e) => setFormData({...formData, isDefault: e.target.checked})}
                        className="rounded border-gray-300 text-blue-600 focus:ring-blue-500"
                      />
                      <span className="text-sm text-gray-700">⭐ Varsayılan Varyant</span>
                    </label>
                  </div>
                  {formData.isDefault && (
                    <div className="mt-2 p-3 bg-yellow-50 border border-yellow-200 rounded-lg">
                      <div className="flex items-start gap-2">
                        <div className="text-yellow-600 mt-0.5">⚠️</div>
                        <div className="text-sm text-yellow-800">
                          <strong>Varsayılan Varyant:</strong> Bu varyant, ürün seçildiğinde otomatik olarak seçili gelecektir. 
                          Her ürün için sadece bir varsayılan varyant olabilir.
                        </div>
                      </div>
                    </div>
                  )}
                </div>

                {/* Common Variant Examples */}
                <div className="bg-gray-50 border border-gray-200 rounded-lg p-4">
                  <h4 className="text-sm font-medium text-gray-900 mb-2">Yaygın Varyant Örnekleri</h4>
                  <div className="grid grid-cols-1 md:grid-cols-2 gap-3 text-sm text-gray-600">
                    <div>
                      <strong>Boyut Varyantları:</strong>
                      <ul className="mt-1 space-y-1">
                        <li>• Küçük (-5₺)</li>
                        <li>• Orta (0₺)</li>
                        <li>• Büyük (+8₺)</li>
                      </ul>
                    </div>
                    <div>
                      <strong>Porsiyon Varyantları:</strong>
                      <ul className="mt-1 space-y-1">
                        <li>• Yarım Porsiyon (-10₺)</li>
                        <li>• Normal Porsiyon (0₺)</li>
                        <li>• Çifte Porsiyon (+15₺)</li>
                      </ul>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div className="p-6 border-t border-gray-200 flex gap-3 justify-end">
              <button
                onClick={() => {
                  setShowModal(false);
                  setEditingVariant(null);
                  resetForm();
                }}
                className="px-4 py-2 text-gray-700 bg-gray-100 hover:bg-gray-200 rounded-lg transition-colors"
              >
                İptal
              </button>
              <button
                onClick={editingVariant ? updateVariant : createVariant}
                className="px-4 py-2 bg-blue-600 hover:bg-blue-700 text-white rounded-lg transition-colors"
              >
                {editingVariant ? 'Güncelle' : 'Oluştur'}
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default ProductVariantsManagement;